import React from 'react';
import { Image } from 'react-konva';

class URLImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            image: null
        };
    }

    componentDidMount() {
        this.loadImage();
    }

    componentDidUpdate = (oldProps) => {
        if (oldProps.src !== this.props.src) this.loadImage();
    };

    componentWillUnmount() {
        this.image.removeEventListener('load', this.handleLoad);
    }

    handleLoad = () => {
        // after setState react-konva will update canvas and redraw the layer
        // because "image" property is changed
        this.setState({
            image: this.image
        });
        // if you keep same image object during source updates
        // you will have to update layer manually:
        // this.imageNode.getLayer().batchDraw();
    };

    loadImage() {
        // save to "this" to remove "load" handler on unmount
        this.image = new window.Image();
        this.image.src = this.props.src;
        this.image.addEventListener('load', this.handleLoad);
    }

    render() {
        return (
            <Image
                x={this.props.x}
                y={this.props.y}
                width={this.props.width}
                height={this.props.height}
                image={this.state.image}
                ref={() => {
                }}
            />
        );
    }
}

export default URLImage;
